const ScrollIcon = () => (
    <p className="scroll-icon">SCROLL</p>
);

export default ScrollIcon;